import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiPlanExpiredError } from '@/core/error/transport/tmApiPlanExpiredError'

export const planExpiredErrorRule: CustomErrorRule = {
  subCodes: ['auth.active_monthly_plan_required', 'auth.buy_monthly_plan'],
  klass: TmApiPlanExpiredError,
}
